export default "__VITE_ASSET__ClWioMKW__"